export const genreColors = {
  ドラマ: "bg-indigo-200",
  "アニメ・特撮": "bg-pink-200",
  映画: "bg-yellow-100",
  バラエティ: "bg-indigo-100",
  "ドキュメンタリー・教養": "bg-yellow-100",
  "ニュース・報道": "bg-blue-100",
  "趣味・教育": "bg-indigo-200",
  スポーツ: "bg-purple-100",
  "情報・ワイドショー": "bg-yellow-100",
  "劇場・公演": "bg-yellow-100",
  音楽: "bg-green-100",
} as { [key: string]: string }
